// src/pages/ScrollTest/ScrollTest.js

import React, { useRef, useEffect, useLayoutEffect } from 'react';
import { gsap } from 'gsap'; // Core GSAP
import { ScrollTrigger } from 'gsap/ScrollTrigger'; // ScrollTrigger plugin
import { useGSAP } from '@gsap/react'; // GSAP for React hook

import '../SaganQuotes/SaganQuotes.scss'; // For basic styling
// Assuming you have 'saganRef' from useRefs context for the main section container.
// Or we can just use a local ref for this single item.

// Register the ScrollTrigger plugin once
gsap.registerPlugin(ScrollTrigger);

const ScrollTest = () => {
    // 1. Create a ref for the element you want to animate
    const animatedBox = useRef();
    const animationContainer = useRef(); // A container to define the scroll area for animation

    // 2. Use useGSAP for animation setup and proper cleanup
    useGSAP(() => {
        // Create a GSAP context for safe cleanup
        gsap.context(() => {
            // Define the animation timeline:
            // This timeline will animate the 'animatedBox'
            const tl = gsap.timeline({
                // Link this timeline to ScrollTrigger
                scrollTrigger: {
                    trigger: animationContainer.current, // The element that defines when the animation starts/ends
                    start: "top bottom", // When 'trigger's top hits viewport's bottom
                    end: "bottom top",   // When 'trigger's bottom leaves viewport's top
                    scrub: true,         // Link animation progress to scroll (+/- true, or number)
                    // Once you get it working, you can add markers for debugging:
                    // markers: true,
                }
            });

            // What the timeline does:
            // It animates 'animatedBox' from its initial state (off-screen, transparent)
            // to its final state (on-screen, opaque).
            // ScrollTrigger will then 'scrub' this animation.

            tl.from(animatedBox.current, { // .from() animates from these values to current CSS values
                x: -500, // Start 500px to the left (adjust as needed for "further out")
                opacity: 0, // Start fully transparent
                duration: 1, // Normalized duration for the timeline
                ease: "none" // Linear animation for scrubbing
            });
            // You can add more steps, e.g.,
            // .to(animatedBox.current, {rotation: 360, duration: 1}, "<"); // Spin while moving

        }, [animationContainer]); // Dependencies for GSAP context

    }, [animationContainer]); // Dependencies for useGSAP hook (re-run if animationContainer changes)

    return (
        // This is a simple container to give us scroll space
        <div ref={animationContainer} style={{ height: '150vh', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>
            {/* The element to be animated */}
            <div ref={animatedBox} style={{
                width: '300px',
                height: '150px',
                backgroundColor: 'blue',
                color: 'white',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '24px',
                textAlign: 'center',
                borderRadius: '10px'
            }}>
                I animate with scroll!
            </div>
        </div>
    );
};

export default ScrollTest